import { MultichainActionType } from '@popup/multichain/actions/action-type.enum';
export const addToLoadingList = (operation, privateKeyType, operationParams, hideDots) => {
    return {
        type: MultichainActionType.ADD_TO_LOADING_LIST,
        payload: {
            operation: operation,
            operationParams: operationParams,
            privateKeyType: privateKeyType,
            hideDots: hideDots,
        },
    };
};
export const removeFromLoadingList = (operation) => {
    return {
        type: MultichainActionType.REMOVE_FROM_LOADING_LIST,
        payload: { operation: operation },
    };
};
export const addCaptionToLoading = (caption) => {
    return {
        type: MultichainActionType.ADD_CAPTION_TO_LOADING_PAGE,
        payload: { caption: caption },
    };
};
export const setLoadingPercentage = (percentage) => {
    return {
        type: MultichainActionType.ADD_LOADING_PERCENTAGE,
        payload: { loadingPercentage: percentage },
    };
};
